module.exports = __webpack_public_path__ + "img/Roof.d6220072.jpg";